import { render, staticRenderFns } from "./JSearchSelectTag.vue?vue&type=template&id=1d063438&scoped=true&"
import script from "./JSearchSelectTag.vue?vue&type=script&lang=js&"
export * from "./JSearchSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d063438",
  null
  
)

export default component.exports